export default __webpack_public_path__ + "59063cf182e96d238a287ca173152e58.svg";